var __TEMP__ = require('./_overArg.js');var overArg = __REQUIRE_DEFAULT__(__TEMP__);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = getPrototype;
